module.exports = __webpack_public_path__ + "img/missionaries14_2019_7-7-2021.2676151a.jpg";